<template>
  <app-detail-modal
    modal-id="modal-detail"
    :title="modalTitle"
    :preloader="preloader"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
        <div class="form-group row align-items-center">
            <div class="col-md-12">
                <table class="table-header">
                    <tr>
                        <td>
                            Product Name
                        </td>
                        <td >
                            :
                        </td>
                        <td >
                            {{ product.name }}
                        </td>
                        <td>
                            Price
                        </td>
                        <td >
                            :
                        </td>
                        <td>
                            {{ product.price }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Level
                        </td>
                        <td >
                            :
                        </td>
                        <td>
                            {{ product.product_level ? product.product_level.product_level_code : '' }}
                        </td>
                        <td>
                            Category
                        </td>
                        <td >
                            :
                        </td>
                        <td>
                            {{ product.product_category ? product.product_category.name : '' }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Description
                        </td>
                        <td>
                            :
                        </td>
                        <td>
                            {{ product.description }}
                        </td>
                        <td>
                            
                        </td>
                        <td>
                           
                        </td>
                        <td>
                           
                        </td>
                    </tr>
                </table>
            </div>
            <div class="col-md-12">
                <br>
            </div>
            <div class="col-md-12">
                <span class="title-header-package">List Packages</span>
            </div>

            <div v-for="(pack, pIndex) in product.list_packages" :key="pIndex"  class="col-md-12">
                <table class="table table-bordered table-package align-middle w-100">
                    <tr>
                        <th :colspan="8" class="text-center font-weight-bold title-header-package">
                            {{ pack.package_name }}
                        </th>
                    </tr>

                    <tr>
                        <th rowspan="2" class="text-center">Class Name</th>
                        <th colspan="5" class="text-center">Schedule</th>
                        <th rowspan="2" class="text-center">Start Date</th>
                        <th rowspan="2" class="text-center">End Date</th>
                    </tr>
                    <tr>
                        <th class="text-center">Monday</th>
                        <th class="text-center">Tuesday</th>
                        <th class="text-center">Wednesday</th>
                        <th class="text-center">Thursday</th>
                        <th class="text-center">Friday</th>
                    </tr>
                    <tr v-for="(course, cIndex) in pack.course_list_packages" :key="cIndex">
                        <td>{{ course.course?.course_name }}</td>

                        <td class="text-center">{{ getScheduleByDay(course, 1) }}</td>

                        <td class="text-center">{{ getScheduleByDay(course, 2) }}</td>

                        <td class="text-center">{{ getScheduleByDay(course, 3) }}</td>

                        <td class="text-center">{{ getScheduleByDay(course, 4) }}</td>

                        <td class="text-center">{{ getScheduleByDay(course, 5) }}</td>

                        <td class="text-center">{{ course.course?.course_date_clc_start }}</td>
                        <td class="text-center">{{ course.course?.course_date_clc_end }}</td>
                    </tr>

                </table>
            </div>

        </div>
    </template>
  </app-detail-modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
export default {
  name: "ModalDetail",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    formId: String,
    value: {
      type: Object,
      default: () => {
        return {
          
          is_active: ""
        };
      },
    },
  },
  data() {
    return {
      preloader: false,
     
      product: {},

      modalId: this.formId,
      modalTitle: 'Detail',
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = 'Detail';
      this.preloader = true;
    }
  },
  mounted() {
    
  },
  methods: {
    getScheduleByDay(course, day) {
        if (course.course?.day !== day) return "";

        const start = course.course?.time_start?.slice(0,5) || "";
        const end = course.course?.time_end?.slice(0,5) || "";

        return `${start} - ${end}`;
    },
    afterSuccessFromGetEditData(response) {
        this.product = response.data;
        this.preloader = false;
    },
 
  },
  watch: {
  }

};
</script>
<style scoped>

::v-deep .title-header-package {
    color: black;
    font-weight: 400;
    font-size: 16px;
}
.table-package th{
    color:white;
    background:#007bff;
    vertical-align: middle !important;
}
.table-header td{
    padding:5px; padding-right:10px; padding-left: 10px;
}
::v-deep(.modal-dialog) {
    width: 1200px !important;
    max-width: 1200px !important;

}
</style>

